import { ShareAttachmentFragment } from "~/__generated__/graphql"
import { EpisodeCard } from "~/share/components/episode-card"

type EpisodeData = NonNullable<ShareAttachmentFragment["episode"]>

interface Props {
  episode: EpisodeData
}

export const MessageAttachmentEpisode: React.FC<Props> = ({ episode }) => (
  <EpisodeCard episode={episode} className="w-full min-w-[260px] max-w-[360px]" />
)
